module.exports = __webpack_public_path__ + "static/media/logo.5c0e561b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 947
// module chunks = 1